var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2353",
    "data-name": "Rectangle 2353",
    width: 24,
    height: 24,
    transform: "translate(0 0.001)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10287",
    "data-name": "Group 10287",
    transform: "translate(0 0.336)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10286",
    "data-name": "Group 10286",
    transform: "translate(0 -0.337)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27604",
    "data-name": "Path 27604",
    d: "M15.048,8.036,9.976,13.119,8.023,11.166a1.185,1.185,0,1,0-1.671,1.671l2.78,2.791a1.2,1.2,0,0,0,.844.345,1.166,1.166,0,0,0,.827-.345l5.916-5.916a1.183,1.183,0,1,0-1.671-1.675M11.831,0A11.831,11.831,0,1,0,23.663,11.831,11.834,11.834,0,0,0,11.831,0m0,21.3A9.465,9.465,0,1,1,21.3,11.831,9.469,9.469,0,0,1,11.831,21.3",
    transform: "translate(0 0.337)",
    fill: "#161615"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedIcon);
export default __webpack_public_path__ + "static/media/checked_icon.035229bc5077561b64951decbeaf7b93.svg";
export { ForwardRef as ReactComponent };